import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SubtleBadge from "components/common/SubtleBadge";
import { useAuth } from "contexts/AuthContext";
import useFormattedDate from "hooks/useFormatDate";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

export const ApiKeyUpdateModal = ({
  selectedKey,
  loading,
  showUpdateModal,
  setShowUpdateModal,
  updateApiKey,
}) => {
  const [status, setStatus] = useState("");
  const { user } = useAuth();
  const { formatDateTime } = useFormattedDate();

  useEffect(() => {
    if (selectedKey) {
      setStatus(selectedKey.active);
    }
  }, [selectedKey]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedKey) return;

    // Copy object and only change active
    const updatedData = {
      ...selectedKey,
      active: status,
      updatedAt: new Date().toISOString(),
      updatedBy: user.id,
    };

    try {
      await updateApiKey(selectedKey.id, updatedData);
    } catch (err) {
      console.error("Error updating API key:", err);
    } finally {
      setShowUpdateModal(false);
      setStatus("");
    }
  };

  return (
    <Modal
      show={showUpdateModal}
      onHide={() => setShowUpdateModal(false)}
      centered
      className="modal-small-text"
    >
      <Modal.Header className="py-3 fw-bold" style={{ fontSize: 14 }}>
        Update API Key
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.83rem" }}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="success" />
          </div>
        ) : selectedKey ? (
          <>
            <div>
              <p className="mb-2">
                <strong>ID:</strong> {selectedKey.id}
              </p>
              <p className="mb-2">
                <strong>Name:</strong> {selectedKey.name}
              </p>
              <p className="mb-2">
                <strong>Client ID:</strong> {selectedKey.clientId}
              </p>
              <p className="mb-2">
                <strong>Key:</strong> {selectedKey.key}
              </p>
              <p className="mb-2">
                <strong>ExpiresAt:</strong>{" "}
                {formatDateTime(selectedKey.expiresAt)}
              </p>
              <div className="d-flex gap-2">
                <strong>Current status:</strong>{" "}
                {selectedKey.active ? (
                  <SubtleBadge pill bg="success" className="d-block">
                    Active
                    <FontAwesomeIcon
                      icon="check"
                      transform="shrink-2"
                      className="ms-1"
                    />
                  </SubtleBadge>
                ) : (
                  <SubtleBadge pill bg="secondary" className="d-block">
                    Disabled
                    <FontAwesomeIcon
                      icon="ban"
                      transform="shrink-2"
                      className="ms-1"
                    />
                  </SubtleBadge>
                )}
              </div>
            </div>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mt-3">
                <Form.Check
                  type="switch"
                  id="active-check"
                  label={
                    status ? "Active (visible in system)" : "Inactive (hidden)"
                  }
                  checked={status}
                  onChange={(e) => setStatus(e.target.checked)}
                />
              </Form.Group>

              <div className="d-flex justify-content-end mt-4">
                <Button
                  size="sm"
                  variant="secondary"
                  onClick={() => setShowUpdateModal(false)}
                  className="me-2"
                >
                  Cancel
                </Button>
                <Button
                  size="sm"
                  type="submit"
                  variant="success"
                  // disabled={!status}
                >
                  Save
                </Button>
              </div>
            </Form>
          </>
        ) : (
          <p>Api key not found!</p>
        )}
      </Modal.Body>
    </Modal>
  );
};
